import { useTranslation } from 'react-i18next'

import { ArrowLeft, X } from '@phosphor-icons/react'

import { IconButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const Header = ({ onClose, onBack, showBack }) => {
  const { t } = useTranslation()
  const title = 'Cuenta bancaria'

  return (
    <Styles.Container>
      <Styles.BackContainer>
        {showBack && <IconButton onClick={onBack} icon={<ArrowLeft size={24} />} variant="text" />}
      </Styles.BackContainer>
      <Text type="titleM">{t(title)}</Text>
      <IconButton onClick={onClose} icon={<X size={24} />} variant="text" />
    </Styles.Container>
  )
}

export default Header
